import axios from "axios";
import _ from "lodash";
import constants from "@/config/constants";
function initialState() {
    return {
        item: {
            _id: null,
            event_id: null,
            scrolling_text: null,
            exhibition_video: null,
            skybox_picture: null,
            environment_picture: null,
            exhibition_picture: null,
            scrolling_text_background_color: null,
            max_count_booth: null,
            exhibition_area:null,
            background_picture:null,
            flag            :[],
            banner_long     :[],
            banner_small    :[],
            banner_medium   :[],
            screen_document1: null,
            screen_document2: null,
            screen_video1: null,
            screen_video2: null,
            skybox: null,
            environment: null,
            skybox_is_custom        :   true,
            environment_is_custom   :   true,
            screen_document1_slides:[],
            screen_document2_slides:[],
            model1:null,
            model2:null,
          
            screen_1_description: 'Screen Description 1',
            screen_2_description: 'Screen Description 2',
        },
        skyboxes: [
            { "id": 'Day Time', "title": "Day Time" },
            { "id": 'Night Time', "title": "Night Time" },
            { "id": 'Dusk', "title": "Dusk" },

        ],
        environments: [
            { "id": 'Mountains', "title": "Mountains" },
            { "id": 'City Landscape', "title": "City Landscape" },
            { "id": 'Forest', "title": "Forest" },

        ],
        loading: false,
    }
}

const getters = {
    item: state => state.item,
    loading: state => state.loading,
    //eventsAll: state => state.eventsAll,
    event_type: state => state.event_type,
    skyboxes: state => state.skyboxes,
    environments: state => state.environments,
}

const actions = {
    storeData({ commit, state, dispatch }) {
        commit('setLoading', true)
       
    },
    updateData({ commit, state }) {
        commit('setLoading', true)



        let params = _.cloneDeep(state.item);
        // params = _.omitBy(params, _.isNil);
        console.log("paramsparamsparams",params);

        delete params._id;
       // delete params.event_id;
       // delete params.event_id;
        delete params.createdAt;
        delete params.updatedAt;
        delete params.__v;
        delete params.left_pics_no_1;
        delete params.left_pics_no_2;
        delete params.left_pics_no_3;
        delete params.left_pics_no_4;
        delete params.left_pics_no_5;
        delete params.right_pics_no_1;
        delete params.right_pics_no_2;
        delete params.right_pics_no_3;
        delete params.right_pics_no_4;
        delete params.right_pics_no_5;
        delete params.right_pics_no_6;
        delete params.exhibition_document_slides;

         if (_.has(state.item.model1, 'key')) {
            let imgPath = _.replace(state.item.model1.key, '/draft', '');
            params.model1 = {
                key: imgPath,
                old_key: (!_.isNull(state.item.model1.key) && !_.isNull(state.item.model1.key.match(/\/draft\//g))) ? state.item.model1.key : null,
                size: params.model1.size,
                extension: params.model1.extension,
                uploadedBy: params.model1.uploadedBy,
                uploadedAt: params.model1.uploadedAt,
                temp_key:  params.model1.temp_key
            }
        }


        if (_.has(state.item.model2, 'key')) {
            let imgPath = _.replace(state.item.model2.key, '/draft', '');
            params.model2 = {
                key: imgPath,
                old_key: (!_.isNull(state.item.model2.key) && !_.isNull(state.item.model2.key.match(/\/draft\//g))) ? state.item.model2.key : null,
                size: params.model2.size,
                extension: params.model2.extension,
                uploadedBy: params.model2.uploadedBy,
                uploadedAt: params.model2.uploadedAt,
                temp_key:  params.model2.temp_key
            }
        }



        if (_.has(state.item.exhibition_area, 'key')) {
            let imgPath = _.replace(state.item.exhibition_area.key, '/draft', '');
            params.exhibition_area = {
                key: imgPath,
                old_key: (!_.isNull(state.item.exhibition_area.key) && !_.isNull(state.item.exhibition_area.key.match(/\/draft\//g))) ? state.item.exhibition_area.key : null,
                size: params.exhibition_area.size,
                extension: params.exhibition_area.extension,
                uploadedBy: params.exhibition_area.uploadedBy,
                uploadedAt: params.exhibition_area.uploadedAt,
            }
        }

        if (_.has(state.item.background_picture, 'key')) {
            let imgPath = _.replace(state.item.background_picture.key, '/draft', '');
            params.background_picture = {
                key: imgPath,
                old_key: (!_.isNull(state.item.background_picture.key) && !_.isNull(state.item.background_picture.key.match(/\/draft\//g))) ? state.item.background_picture.key : null,
                size: params.background_picture.size,
                extension: params.background_picture.extension,
                uploadedBy: params.background_picture.uploadedBy,
                uploadedAt: params.background_picture.uploadedAt,
                temp_key:  params.background_picture.temp_key
            }
        }

        if (_.has(state.item.skybox_picture, 'key')) {
            let imgPath = _.replace(state.item.skybox_picture.key, '/draft', '');
            params.skybox_picture = {
                key: imgPath,
                old_key: (!_.isNull(state.item.skybox_picture.key) && !_.isNull(state.item.skybox_picture.key.match(/\/draft\//g))) ? state.item.skybox_picture.key : null,
                size: params.skybox_picture.size,
                extension: params.skybox_picture.extension,
                uploadedBy: params.skybox_picture.uploadedBy,
                uploadedAt: params.skybox_picture.uploadedAt,
                temp_key:  params.skybox_picture.temp_key
            }
        }

        if (_.has(state.item.environment_picture, 'key')) {
            let imgPath = _.replace(state.item.environment_picture.key, '/draft', '');
            params.environment_picture = {
                key: imgPath,
                old_key: (!_.isNull(state.item.environment_picture.key) && !_.isNull(state.item.environment_picture.key.match(/\/draft\//g))) ? state.item.environment_picture.key : null,
                size: params.environment_picture.size,
                extension: params.environment_picture.extension,
                uploadedBy: params.environment_picture.uploadedBy,
                uploadedAt: params.environment_picture.uploadedAt,
                temp_key:  params.environment_picture.temp_key
            }
        }
        if (_.has(state.item.screen_video1, 'key')) {
            let imgPath = _.replace(state.item.screen_video1.key, '/draft', '');
            params.screen_video1 = {
                key: imgPath,
                old_key: (!_.isNull(state.item.screen_video1.key) && !_.isNull(state.item.screen_video1.key.match(/\/draft\//g))) ? state.item.screen_video1.key : null,
                size: params.screen_video1.size,
                extension: params.screen_video1.extension,
                uploadedBy: params.screen_video1.uploadedBy,
                uploadedAt: params.screen_video1.uploadedAt,
                temp_key:  params.screen_video1.temp_key
            }
        }
        if (_.has(state.item.screen_video2, 'key')) {
            let imgPath = _.replace(state.item.screen_video2.key, '/draft', '');
            params.screen_video2 = {
                key: imgPath,
                old_key: (!_.isNull(state.item.screen_video2.key) && !_.isNull(state.item.screen_video2.key.match(/\/draft\//g))) ? state.item.screen_video2.key : null,
                size: params.screen_video2.size,
                extension: params.screen_video2.extension,
                uploadedBy: params.screen_video2.uploadedBy,
                uploadedAt: params.screen_video2.uploadedAt,
                temp_key:  params.screen_video2.temp_key
            }
        }
        if (_.has(state.item.screen_document1, 'key')) {
            let imgPath = _.replace(state.item.screen_document1.key, '/draft', '');
            params.screen_document1 = {
                key: imgPath,
                old_key: (!_.isNull(state.item.screen_document1.key) && !_.isNull(state.item.screen_document1.key.match(/\/draft\//g))) ? state.item.screen_document1.key : null,
                size: params.screen_document1.size,
                extension: params.screen_document1.extension,
                uploadedBy: params.screen_document1.uploadedBy,
                uploadedAt: params.screen_document1.uploadedAt,
                temp_key:  params.screen_document1.temp_key
            }
        }
        if (_.has(state.item.screen_document2, 'key')) {
            let imgPath = _.replace(state.item.screen_document2.key, '/draft', '');
            params.screen_document2 = {
                key: imgPath,
                old_key: (!_.isNull(state.item.screen_document2.key) && !_.isNull(state.item.screen_document2.key.match(/\/draft\//g))) ? state.item.screen_document2.key : null,
                size: params.screen_document2.size,
                extension: params.screen_document2.extension,
                uploadedBy: params.screen_document2.uploadedBy,
                uploadedAt: params.screen_document2.uploadedAt,
                temp_key:  params.screen_document2.temp_key
            }
        }
        
        return axios.patch(constants.API_EVENT_HALL_URL + '/api/v1/event-hall/' + state.item.event_id + '/' + state.item._id, params)
    
            .then(response => {
                commit('setItem', response.data.data.value)
                return response;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    fetchData({ commit, dispatch }, params) {
        commit('setLoading', true)
        commit('setEvent', params.event_id)
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return axios.get(constants.API_URL + `/api/event-hall/${params.event_id}/${params.event_hall_id}/`,{headers: headers})
            .then(response => {
                
                commit('setItem', response.data.data)
                return response
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    removeFlags({commit}, value){
        commit('removeFlags', value);
    },
    setFlags({commit},value){
       commit('setFlags',value);
    },
    fetchEventsAll({ commit }, event_id) {
        commit('setEvent', event_id)
    },
    getEventTimeZone({ commit, state, dispatch }, event_id) {
        axios.get(constants.API_URL + '/api/v1/event_details/' + event_id)
            .then(response => {
                commit('setEventType', response.data.data[0].event_type)
                state.event_type = response.data.data[0].event_type
            })

    },
    setEvent({ commit }, value) {
        commit('setEvent', value)
    },
    setSkybox({ commit }, value) {
        commit('setSkybox', value)
    },
    setSkyboxPicture({ commit }, value) {
        commit('setSkyboxPicture', value)
    },
    setEnvironment({ commit }, value) {
        commit('setEnvironment', value)
    },
    setSkybox_is_custom({ commit }, value) {
        commit('setSkybox_is_custom', value)
    },
    setEnvironment_is_custom({ commit }, value) {
        commit('setEnvironment_is_custom', value)
    },
    setAuditorium_live({ commit }, value) {
        commit('setAuditorium_live', value)
    },
    setExhibitionPicture({ commit }, value) {
        commit('setExhibitionPicture', value)
    },
    
    setAuditorium_pre_recorded({ commit }, value) {
        commit('setAuditorium_pre_recorded', value)
    },

    setAuditorium_panel_discussion({ commit }, value) {
        commit('setAuditorium_panel_discussion', value)
    },

    setExhibition_area({ commit }, value) {
        commit('setExhibition_area', value)
    },

    setVirtual_training({ commit }, value) {
        commit('setVirtual_training', value)
    },
    setRoundtable({ commit }, value) {
        commit('setRoundtable', value)
    },

    setVirtual_meeting({ commit }, value) {
        commit('setVirtual_meeting', value)
    },
    setAuditorium_live_label({ commit }, value) {
        commit('setAuditorium_live_label', value)
    },
    setScrollingText({ commit }, value) {
        commit('setScrollingText', value)
    },

    setAuditorium_pre_recorded_label({ commit }, value) {
        commit('setAuditorium_pre_recorded_label', value)
    },

    setAuditorium_panel_discussion_label({ commit }, value) {
        commit('setAuditorium_panel_discussion_label', value)
    },

    setExhibition_area_label({ commit }, value) {
        commit('setExhibition_area_label', value)
    },

    setVirtual_training_label({ commit }, value) {
        commit('setVirtual_training_label', value)
    },
    setRoundtable_label({ commit }, value) {
        commit('setRoundtable_label', value)
    },

    setVirtual_meeting_label({ commit }, value) {
        commit('setVirtual_meeting_label', value)
    },

    setExhibition_video({ commit }, value) {
        commit('setExhibition_video', value)
    },
    setScreen_video1({ commit }, value) {
        commit('setScreen_video1', value)
    },
    setScreen_video2({ commit }, value) {
        commit('setScreen_video2', value)
    },
    setScreen_video3({ commit }, value) {
        commit('setScreen_video3', value)
    },
    setScreen_video4({ commit }, value) {
        commit('setScreen_video4', value)
    },
    setScreen_video5({ commit }, value) {
        commit('setScreen_video5', value)
    },
    setScreen_video6({ commit }, value) {
        commit('setScreen_video6', value)
    },
    setScreen_video7({ commit }, value) {
        commit('setScreen_video7', value)
    },
    setScreenDesc1({ commit }, value) {
        commit('setScreenDesc1', value)
    },
    setScreenDesc2({ commit }, value) {
        commit('setScreenDesc2', value)
    },
    setExhibition_document({ commit }, value) {
        commit('setExhibition_document', value)
    },
    setScreen_document1({ commit }, value) {
        commit('setScreen_document1', value)
    },
    setScreen_document2({ commit }, value) {
        commit('setScreen_document2', value)
    },
    setScreen_document3({ commit }, value) {
        commit('setScreen_document3', value)
    },
    setScreen_document4({ commit }, value) {
        commit('setScreen_document4', value)
    },
    setScreen_document5({ commit }, value) {
        commit('setScreen_document5', value)
    },
    setScreen_document6({ commit }, value) {
        commit('setScreen_document6', value)
    },
    setScreen_document7({ commit }, value) {
        commit('setScreen_document7', value)
    },
    setLogo_standee({ commit }, value) {
        commit('setLogo_standee', value)
    },
    setBackgroundPicture({ commit }, value) {
        commit('setBackgroundPicture', value)
    },
    setEnvironmentPicture({ commit }, value) {
        commit('setEnvironmentPicture', value)
    },
    setBackgroundColor({ commit }, value) {
        commit('setBackgroundColor', value)
    },
    setBackgroundColorBottom({ commit }, value) {
        commit('setBackgroundColorBottom', value)
    },
    setMaxCountBooth({ commit }, value) {
        commit('setMaxCountBooth', value)
    },
    setIs_picture({ commit }, value) {
        commit('setIs_picture', value)
    },
    resetState({ commit }) {
        commit('resetState')
    },
    setBannerLong({ commit }, value) {
        commit('setBannerLong', value)
    },
    removeBannerLong({ commit }, value) {
        commit('removeBannerLong', value)
    },
    setBannerSmall({ commit }, value) {
        commit('setBannerSmall', value)
    },
    removeBannerSmall({ commit }, value) {
        commit('removeBannerSmall', value)
    },
    setBannerMedium({ commit }, value) {
        commit('setBannerMedium', value)
    },
    removeBannerMedium({ commit }, value) {
        commit('removeBannerMedium', value)
    },
    setModel1({ commit }, value) {
        commit('setModel1', value)
    },
    setModel2({ commit }, value) {
        commit('setModel2', value)
    },
    setScrollingTextBackground({ commit }, value) {
        commit('setScrollingTextBackground', value);
    }
}

const mutations = {
    setScrollingTextBackground(state, value) {
        state.item.scrolling_text_background_color = value;
    },
    setModel1(state, value) {
        state.item.model1 = value

    },
    setModel2(state, value) {
        state.item.model2 = value 
    },
    setEventType(state, value) {
        state.event_type = value
    },
    setItem(state, item) {
        state.item = item

    },
    setScreenDesc1(state, value) {
        state.item.screen_1_description = value
    },
    setScreenDesc2(state, value) {
        state.item.screen_2_description = value
    },
    setSkybox_is_custom(state, value) {
        state.item.skybox_is_custom = value
        
    },
    setEnvironment_is_custom(state, value) {
        state.item.environment_is_custom = value
        
    },
    setEvent(state, value) {
        state.item.event_id = value
    },
    setSkybox(state, value) {
        state.item.skybox = value
    },
    setEnvironment(state, value) {
        state.item.environment = value
    },
    setAuditorium_live(state, value) {
        state.item.auditorium_live = value
    },
    setExhibitionPicture(state, value) {
        state.item.exhibition_picture = value
    },
 
    setAuditorium_pre_recorded(state, value) {
        state.item.auditorium_pre_recorded = value
        
    },
    setAuditorium_panel_discussion(state, value) {
        state.item.auditorium_panel_discussion = value
        
    },
    setExhibition_area(state, value) {
        state.item.exhibition_area = value
        
    },
    setVirtual_training(state, value) {
        state.item.virtual_training = value
        
    },
    setRoundtable(state, value) {
        state.item.roundtable = value
        
    },
    setVirtual_meeting(state, value) {
        state.item.virtual_meeting = value
        
    },
    setScrollingText(state, value) {
        state.item.scrolling_text = value

    },
    setAuditorium_live_label(state, value) {
        state.item.auditorium_live_label = value

    },
    setAuditorium_pre_recorded_label(state, value) {
        state.item.auditorium_pre_recorded_label = value

    },
    setAuditorium_panel_discussion_label(state, value) {
        state.item.auditorium_panel_discussion_label = value

    },
    setExhibition_area_label(state, value) {
        state.item.exhibition_area_label = value

    },
    setVirtual_training_label(state, value) {
        state.item.virtual_training_label = value

    },
    setRoundtable_label(state, value) {
        state.item.roundtable_label = value

    },
    setVirtual_meeting_label(state, value) {
        state.item.virtual_meeting_label = value

    },
    setExhibition_video(state, value) {
        state.item.exhibition_video = value
       
    },
    setScreen_video1(state, value) {
        state.item.screen_video1 = value
       
    },
    setScreen_video2(state, value) {
        state.item.screen_video2 = value
        
    },
    setScreen_video3(state, value) {
        state.item.screen_video3 = value
       
    },
    setScreen_video4(state, value) {
        state.item.screen_video4 = value
        
    },
    setScreen_video5(state, value) {
        state.item.screen_video5 = value
        
    },
    setScreen_video6(state, value) {
        state.item.screen_video6 = value
       
    },
    setScreen_video7(state, value) {
        state.item.screen_video7 = value
        
    },
    setExhibition_document(state, value) {
        state.item.exhibition_document = value
       
    },
    setScreen_document1(state, value) {
        state.item.screen_document1 = value
        
    },
    setScreen_document2(state, value) {
        state.item.screen_document2 = value
       
    },
    setScreen_document3(state, value) {
        state.item.screen_document3 = value
       
    },
    setScreen_document4(state, value) {
        state.item.screen_document4 = value
       
    },
    setScreen_document5(state, value) {
        state.item.screen_document5 = value
        if (value == '') {
            state.item.screen_document5_delete = 1
        } else {
            state.item.screen_document5_delete = 0
        }
    },
    setScreen_document6(state, value) {
        state.item.screen_document6 = value
        if (value == '') {
            state.item.screen_document6_delete = 1
        } else {
            state.item.screen_document6_delete = 0
        }
    },
    setScreen_document7(state, value) {
        state.item.screen_document7 = value
        if (value == '') {
            state.item.screen_document7_delete = 1
        } else {
            state.item.screen_document7_delete = 0
        }
    },
    setLogo_standee(state, value) {
        state.item.logo_standee = value
        
    },
    setBackgroundPicture(state, value) {
        state.item.background_picture = value
        
    },
    setBackgroundColor(state, value) {
        state.item.background_color_top = value
    },
    setBackgroundColorBottom(state, value) {
        state.item.background_color_bottom = value
    },
    setMaxCountBooth(state, value) {
        state.item.max_count_booth = value
    },
    setIs_picture(state, value) {
        state.item.is_picture = value
    },
    setSkyboxPicture(state,value){
        state.item.skybox_picture = value;
    },
    setEnvironmentPicture(state, value){
        state.item.environment_picture = value;
    },
    setFlags(state,value){
        state.item.flag.push(value);
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    removeFlags(state, value) {
        const index = state.item.flag.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.flag.splice(index, 1);
        }
       /* for (let i of state.item.flag) {
            if (i.key == value) {
                state.item.flag.splice(i.key, 1);
            }
        }*/
    },
    setBannerLong(state,value){
        state.item.banner_long.push(value);
    },
    removeBannerLong(state, value) {
        const index = state.item.banner_long.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.banner_long.splice(index, 1);
        }
        /*for (let i of state.item.banner_long) {
            if (i.key == value) {
                state.item.banner_long.splice(i.key, 1);
            }
        }*/
    },
    setBannerSmall(state,value){
        state.item.banner_small.push(value);
    },
    removeBannerSmall(state, value) {
        const index = state.item.banner_small.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.banner_small.splice(index, 1);
        }
        /*for (let i of state.item.banner_small) {
            if (i.key == value) {
                state.item.banner_small.splice(i.key, 1);
            }
        }*/
    },
    setBannerMedium(state,value){
        state.item.banner_medium.push(value);
    },
    removeBannerMedium(state, value) {
        const index = state.item.banner_medium.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.banner_medium.splice(index, 1);
        }
       /* for (let i of state.item.banner_small) {
            if (i.key == value) {
                state.item.banner_medium.splice(i.key, 1);
            }
        }*/
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
